<template>
    <div
        class="gauge"
        :style="{height: (!isMobile) ? height + 'px' : false }">

        <tooltip
            :tooltip="`${$t('yourself')} (${userData}%)`"
            class="gauge__user-value"
            :style="{left: userData + '%'}">

            <template v-if="gender === 'M'">
                <img
                    class="gauge__user-value-artwork"
                    src="@/assets/images/artworks/who-i-am/man-plain.svg"
                    alt="" />
            </template>
            <template v-else>
                <img
                    class="gauge__user-value-artwork"
                    src="@/assets/images/artworks/who-i-am/woman-plain.svg"
                    alt="" />
            </template>
        </tooltip>

        <div class="gauge__x-axis">
            <span class="gauge__x-axis-icon gauge__x-axis-icon--min cursor-location">
                <img
                    class="cursor-location__icon"
                    src="@/assets/images/artworks/cursor-location.svg"
                    alt="" />
                <span class="cursor-location__label">
                    -
                </span>
            </span>


            <span class="gauge__x-axis-icon gauge__x-axis-icon--max cursor-location">
                <img
                    class="cursor-location__icon"
                    src="@/assets/images/artworks/cursor-location.svg"
                    alt="">
                <span class="cursor-location__label">
                    +
                </span>
            </span>
        </div>


        <ul class="gauge__list">
            <li
                v-for="(item, key) in formatedData"
                class="gauge__item"
                :style="{left: (!isMobile) ? item.x + '%' : false, paddingTop: (!isMobile) ? item.y + 'px' : '20px', zIndex: -1 - key}"
                :key="`item-${key}`">

                <div class="gauge__item-decorative-line"></div>

                <tooltip
                    :tooltip="`${capitalize(item.label)} (${item.x}%)`"
                    trigger-class="gauge__circle"
                >
                    <span class="gauge__circle-label">{{ capitalize(item.label.substr(0, 2)) }}</span>
                </tooltip>
            </li>
        </ul>
    </div>
</template>

<script>

import Vue from "vue";

import Tooltip from "@/components/tooltip/Tooltip.vue";

export default {
    name: "Gauge",
    components: {
        Tooltip: Tooltip
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        gender: {
            type: String,
            required: true
        },
        userData: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            isMobile: true,
        };
    },
    computed: {
        sortedData() {
            const array = this.data;
            return array.sort((a, b) => {

                // Filter on X (decreasing)
                const xSort = a.x - b.x;

                if (xSort !== 0) {
                    return xSort;
                }

                // If X are the same, filter on Y
                const ySort = a.y - b.y;

                return ySort;

            });
        },
        formatedData() {

            const formatedData = this.sortedData.map((item, index, array) => {
                return {
                    id: item.id,
                    x: item.x,
                    y: item.y * 100,
                    label: item.label,
                };

            });

            return formatedData;
        },
        values() {
            // Create an array only containing all values of sortedData
            return Array.from(this.sortedData, (item => item.x));
        },
        min() {
            // Retrieve the smallest value of all
            return Math.min(...this.x);
        },
        max() {
            // Retrieve the highest value of all
            return Math.max(...this.x);
        },
        scale() {
            return this.max - this.min;
        },
        maxY() {
            // Create an array only containing all Y of formatedData
            const array = Array.from(this.formatedData, (item => item.y));
            // Retrieve the max value of it
            return Math.max(...array);
        },
        height() {
            return this.maxY + 80 + 216;
        },
        // currentGender() {
        //     if (this.gender === "M") {
        //         return "man";
        //     } else {
        //         return "woman";
        //     }
        // },
    },
    mounted() {
        // Responsive Behavior
        /* istanbul ignore next */
        this.$responsive.registerMediaQuery("from-medium", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },
};
</script>